module.exports = __webpack_public_path__ + "img/wallpaper17.2c7f0042.png";